// generateReceiptHTML.js
import React from 'react';
// On importe le logo en tant que base64 ou URL publique
// Si le logo est dans le dossier public, on peut utiliser un chemin relatif
// Sinon, on peut le convertir en base64

export const genererHTMLReçu = (Client, modePaiement, formData, ClientEnregistre, selectedData = null) => {
  const ClientData = Client || ClientEnregistre;
  const paiement = modePaiement || (formData ? formData.mode_Paie_OP : '');

  // Récupérer les analyses soit de ClientData.analyses, soit de selectedData
  const analysesAfficher = ClientData.analyses || (selectedData ? selectedData.analyses : []);

  // Récupérer les actes de consultation soit de ClientData.actes, soit de selectedData
  const actesConsultation = ClientData.actes || (selectedData ? selectedData.actes : []);

  // Calculer le total des analyses
  const totalAnalyses = analysesAfficher.reduce((sum, analyse) => sum + (analyse.prix || 0), 0);

  // Calculer le total des actes de consultation
  const totalActes = actesConsultation.reduce((sum, acte) => sum + (acte.montant || acte.prix || 0), 0);

  // Montant total
  const montantTotal = ClientData.montant || (totalActes + totalAnalyses);

  // Formater la date
  const formatDate = (dateString) => {
    const date = new Date(dateString || new Date());
    return date.toLocaleDateString('fr-FR');
  };

  // Formater l'heure
  const formatHeure = (dateString) => {
    const date = new Date(dateString || new Date());
    return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  };

  // Fonction pour traduire le mode de paiement
  const getPaymentModeText = (mode) => {
    const modes = {
      'espece': 'En espèce',
      'cheque': 'Par Chèque',
      'virement': 'Par Virement',
      'transfert_airtel': 'Transfert AirTel',
      'transfer_tigo': 'Transfert TIGO'
    };
    return modes[mode] || mode;
  };

  // Fonction pour générer une copie A5 paysage
  const generateA5LandscapeCopy = (copyType) => {
    return `
      <div class="a5-landscape-copy ${copyType} rounded-frame">
        <div class="receipt-main-content rounded-content">
          <div class="receipt-header rounded-top">
            <img src="/logo.png" alt="LNE Logo" class="receipt-logo">
            <div class="html-title">
              <h2>LNE - Ndjamena</h2>
            </div>  
            <div class="receipt-number">
              <strong>REÇU N°: ${ClientData.numClient || 'N/A'}</strong>
            </div>
          </div>
       
          <!-- Numéro de reçu -->
          

          <!-- Informations Client -->
          <div class="Client-info-pdf">
            <div class="info-basics">
              <span class="label">Nom du Client:</span>
              <span class="value">${ClientData.nomClient || 'Non spécifié'}</span>
              <span>' ---- '</span>
              <span class="label">Téléphone:</span>
              <span class="value">${ClientData.numAirTel || 'N/A'}</span>
              <span>' ---- '</span>
              Date: ${formatDate(ClientData.dateCreation || ClientData.dateModification)}
              <span>' ---- '</span>
              Heure: ${formatHeure(ClientData.dateCreation || ClientData.dateModification)}
            </div>
          </div>

          <!-- Sections des analyses et actes -->
          ${actesConsultation.length > 0 && analysesAfficher.length > 0 ? `
            <div class="adjacent-sections">
              <!-- Section Consultation -->
              ${actesConsultation.length > 0 ? `
                <div class="consultation-section-adjacent rounded-section">
                  <div class="section-title consultation-title rounded-top-inner">DÉTAIL CONSULTATION</div>
                  <div class="section-content">
                    ${actesConsultation.map((acte, index) => `
                      <div class="item-line">
                        <span class="item-nom">${acte.nom || acte.name || 'Acte médical'}</span>
                        <span class="item-prix">${(acte.montant || acte.prix || 0).toLocaleString()} FCFA</span>
                      </div>
                    `).join('')}
                    <div class="section-total consultation-total rounded-bottom-inner">
                      <span>Total Consultation:</span>
                      <span class="total-amount">${totalActes.toLocaleString()} FCFA</span>
                    </div>
                  </div>
                </div>
              ` : ''}

              <!-- Section Analyses -->
              ${analysesAfficher.length > 0 ? `
                <div class="analyses-section-adjacent rounded-section">
                  <div class="section-title analyses-title rounded-top-inner">DÉTAIL DES ANALYSES</div>
                  <div class="section-content">
                    ${analysesAfficher.map((analyse, index) => `
                      <div class="item-line">
                        <span class="item-nom">${analyse.nom || 'Analyse'}</span>
                        <span class="item-prix">${(analyse.prix || 0).toLocaleString()} FCFA</span>
                      </div>
                    `).join('')}
                    <div class="section-total analyses-total rounded-bottom-inner">
                      <span>Total Analyses:</span>
                      <span>${totalAnalyses.toLocaleString()} FCFA</span>
                    </div>
                  </div>
                </div>
              ` : ''}
            </div>
          ` : ''}

          <!-- Si seulement une section existe -->
          ${actesConsultation.length > 0 && analysesAfficher.length === 0 ? `
            <div class="single-section">
              <div class="single-section-content consultation-section-adjacent rounded-section">
                <div class="section-title consultation-title rounded-top-inner">DÉTAIL CONSULTATION</div>
                <div class="section-content">
                  ${actesConsultation.map((acte, index) => `
                    <div class="item-line">
                      <span class="item-nom">${acte.nom || acte.name || 'Acte médical'}</span>
                      <span class="item-prix">${(acte.montant || acte.prix || 0).toLocaleString()} FCFA</span>
                    </div>
                  `).join('')}
                  <div class="section-total consultation-total rounded-bottom-inner">
                    <span>Total Consultation:</span>
                    <span class="total-amount">${totalActes.toLocaleString()} FCFA</span>
                  </div>
                </div>
              </div>
            </div>
          ` : ''}

          ${analysesAfficher.length > 0 && actesConsultation.length === 0 ? `
            <div class="single-section">
              <div class="single-section-content analyses-section-adjacent rounded-section">
                <div class="section-title analyses-title rounded-top-inner">DÉTAIL DES ANALYSES</div>
                <div class="section-content">
                  ${analysesAfficher.map((analyse, index) => `
                    <div class="item-line">
                      <span class="item-nom">${analyse.nom || 'Analyse'}</span>
                      <span class="item-prix">${(analyse.prix || 0).toLocaleString()} FCFA</span>
                    </div>
                  `).join('')}
                  <div class="section-total analyses-total rounded-bottom-inner">
                    <span>Total Analyses:</span>
                    <span>${totalAnalyses.toLocaleString()} FCFA</span>
                  </div>
                </div>
              </div>
            </div>
          ` : ''}

          <!-- Montant total et mode paiement - margin-top réduit -->
          <div class="total-payment-section rounded-section">
            <!-- Afficher les totaux partiels si les deux sections existent -->
            ${actesConsultation.length > 0 && analysesAfficher.length > 0 ? `
              <div class="partial-totals rounded-inner">
                <div class="partial-total">
                  <span>Consultation:</span>
                  <span>${totalActes.toLocaleString()} FCFA</span>
                </div>
                <div class="partial-total">
                  <span>Analyses:</span>
                  <span>${totalAnalyses.toLocaleString()} FCFA</span>
                </div>
              </div>
            ` : ''}

            <div class="total-line rounded-inner">
              <span class="total-label">Montant Total:</span>
              <span class="total-value">${montantTotal.toLocaleString()} FCFA</span>
            </div>

            ${paiement ? `
              <div class="payment-info rounded-inner">
                <div class="payment-line">
                  <span>Mode de paiement:</span>
                  <span><strong>${getPaymentModeText(paiement)}</strong></span>
                </div>
              </div>
            ` : ''}
          </div>
        </div>
      </div>
    `;
  };

  return `
    <!DOCTYPE html>
    <html lang="fr">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Reçu LNE - ${ClientData.numID_LNE || ClientData.numHPAID || 'N/A'}</title>
        <style>
            /* Reset et base */
            * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
                font-family: 'Arial', sans-serif;
                font-size: 10px;
                line-height: 1.2;
            }

            body {
                background: white;
                margin: 0;
                padding: 0;
                width: 210mm;
                min-height: 297mm;
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            /* Conteneur A4 portrait contenant deux A5 paysage */
            .a4-portrait-container {
                width: 210mm;
                min-height: 297mm;
                display: flex;
                flex-direction: column;
                gap: 0;
                page-break-after: always;
                background: white;
            }

            /* Cadre principal arrondi */
            .rounded-frame {
                border: 2px solid #3498db;
                border-radius: 12px;
                overflow: hidden;
                background: white;
                box-shadow: 0 4px 12px rgba(52, 152, 219, 0.1);
            }

            /* Copie A5 paysage */
            .a5-landscape-copy {
                width: 210mm;
                height: 148.5mm; /* 297mm / 2 = 148.5mm */
                padding: 8mm 10mm;
                display: flex;
                flex-direction: column;
                border-bottom: 1px dashed #ccc;
                page-break-inside: avoid;
                break-inside: avoid;
            }

            .archive-copy {
                border-bottom: none;
                border-top: 1px dashed #ccc;
            }

            /* Contenu principal */
            .receipt-main-content {
                flex: 1;
                display: flex;
                flex-direction: column;
                padding: 5px;
            }

            /* Classes pour les coins arrondis */
            .rounded-top {
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                overflow: hidden;
            }

            .rounded-bottom {
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
                overflow: hidden;
            }

            .rounded-section {
                border: 1px solid #e0e0e0;
                border-radius: 8px;
                overflow: hidden;
                margin-bottom: 6px; /* Réduit */
                background: #fff;
            }

            .rounded-inner {
                border: 1px solid #f0f0f0;
                border-radius: 6px;
                padding: 6px;
                margin-bottom: 4px; /* Réduit */
                background: #f9f9f9;
            }

            .rounded-top-inner {
                border-top-left-radius: 7px;
                border-top-right-radius: 7px;
                border-bottom: 1px solid #ddd;
            }

            .rounded-bottom-inner {
                border-bottom-left-radius: 7px;
                border-bottom-right-radius: 7px;
                border-top: 1px solid #ddd;
            }

            .rounded-content {
                border: 1px solid #e8f4fc;
                border-radius: 8px;
                padding: 8px;
                background: #f8fafc;
                flex: 1;
            }

            /* En-tête */
            .receipt-header {
                text-align: left;
                margin-bottom: 5px;
                border-bottom: 2px solid #3498db;
                padding-bottom: 3px;
                background: linear-gradient(135deg, #f8fafc 0%, #e8f4fc 100%);
                display : flex;
            }
            
            .receipt-logo {
                height: 35px;
                margin-bottom: 3px;
                display: block;
                margin-left: 10px;
            }

            .html-title {
                text-align: left;
                margin-top: 5px;
            }
            
            .html-title h2 {
                font-size: 13px;
                font-weight: bold;
                color: #2c3e50;
                margin: 0;
            }

            /* Numéro de reçu */
            .receipt-number {
                text-align: center;
                font-size: 11px;
                font-weight: bold;
                margin-left: auto;
                /*margin-right: auto;*/
                padding: 6px;
                background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
                color: white;
                border-radius: 6px;
                box-shadow: 0 2px 4px rgba(52, 152, 219, 0.2);
            }

            /* Informations Client */
            .Client-info-pdf {
                margin-bottom: 8px; /* Réduit */
                padding: 6px;
                background: #f8f9fa;
                border-radius: 6px;
                border: 1px solid #e0e0e0;
            }

            .info-basics {
                font-size: 9px;
                line-height: 1.3;
                text-align: center;
            }

            .info-basics .label {
                font-weight: bold;
                color: #2c3e50;
            }

            .info-basics .value {
                color: #34495e;
            }

            /* Sections adjacentes (côte à côte dans la copie A5 paysage) */
            .adjacent-sections {
                display: flex;
                gap: 8px;
                margin-bottom: 10px; /* Réduit */
                min-height: 70mm;
            }
            
            .consultation-section-adjacent,
            .analyses-section-adjacent {
                flex: 1;
                background: #fff;
                border: 1px solid #e0e0e0;
                border-radius: 8px;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                box-shadow: 0 2px 4px rgba(0,0,0,0.05);
            }

            .section-title {
                background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
                color: white;
                padding: 4px 6px;
                font-size: 9px;
                font-weight: bold;
                text-align: center;
                text-transform: uppercase;
                flex-shrink: 0;
                letter-spacing: 0.5px;
            }

            .consultation-title {
                background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
            }

            .analyses-title {
                background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%);
            }

            .section-content {
                padding: 6px;
                flex-grow: 1;
                overflow-y: auto;
                max-height: 55mm;
                background: #fff;
            }

            .item-line {
                display: flex;
                justify-content: space-between;
                padding: 3px 2px;
                border-bottom: 1px dotted #f0f0f0;
                font-size: 8px;
                transition: background-color 0.2s;
            }

            .item-line:hover {
                background-color: #f8f9fa;
            }

            .item-line:last-child {
                border-bottom: none;
            }

            .item-nom {
                flex: 3;
                color: #2c3e50;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-weight: 500;
            }

            .item-prix {
                flex: 1;
                text-align: right;
                color: #27ae60;
                font-weight: bold;
                min-width: 35px;
            }

            .section-total {
                display: flex;
                justify-content: space-between;
                margin-top: 6px;
                padding: 5px 6px;
                border-top: 2px solid #eee;
                font-weight: bold;
                font-size: 9px;
                color: #2c3e50;
                flex-shrink: 0;
                background: #f8f9fa;
            }

            /* Section unique (pleine largeur) */
            .single-section {
                width: 100%;
                margin-bottom: 10px; /* Réduit */
                min-height: 70mm;
            }

            .single-section-content {
                background: #fff;
                border: 1px solid #e0e0e0;
                border-radius: 8px;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                height: 100%;
                box-shadow: 0 2px 4px rgba(0,0,0,0.05);
            }

            /* Totaux partiels */
            .partial-totals {
                background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
                padding: 8px;
                border-radius: 6px;
                margin-bottom: 6px; /* Réduit */
                border-left: 3px solid #f39c12;
                box-shadow: 0 1px 3px rgba(243, 156, 18, 0.1);
            }

            .partial-total {
                display: flex;
                justify-content: space-between;
                margin-bottom: 4px;
                font-size: 9px;
                padding: 2px 0;
            }

            .partial-total span:first-child {
                font-weight: bold;
                color: #2c3e50;
            }

            .partial-total span:last-child {
                color: #27ae60;
                font-weight: bold;
            }

            /* Total général - margin-top réduit de 8px à 4px */
            .total-payment-section {
                margin-top: 4px; /* Réduit de 8px à 4px */
                padding: 8px; /* Réduit de 10px à 8px */
                border: 2px solid #3498db;
                border-radius: 8px;
                background: linear-gradient(135deg, #f8fafc 0%, #e8f4fc 100%);
            }

            .total-line {
                display: flex;
                justify-content: space-between;
                font-size: 11px;
                font-weight: bold;
                color: #2c3e50;
                margin-bottom: 4px; /* Réduit */
                padding: 6px;
                background: white;
                border-radius: 4px;
                box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            }

            .total-label {
                font-weight: bold;
            }

            .total-value {
                color: #e74c3c;
                font-size: 12px;
            }

            /* Informations de paiement */
            .payment-info {
                background: linear-gradient(135deg, #e8f4fc 0%, #d4e6f1 100%);
                padding: 6px;
                border-radius: 4px;
                margin-top: 4px; /* Réduit */
                font-size: 8px;
                border: 1px solid #aed6f1;
            }

            .payment-line {
                display: flex;
                justify-content: space-between;
                margin-bottom: 2px;
                font-weight: 500;
            }

            /* Signature */
            .pdf-footer {
                margin-top: 6px; /* Réduit */
                padding-top: 8px; /* Réduit */
                border-top: 1px solid #ddd;
                text-align: center;
                background: #f8f9fa;
                padding: 8px;
                border-radius: 6px;
            }

            .signature-area {
                margin-bottom: 6px; /* Réduit */
            }

            .signature-line-pdf {
                width: 60mm;
                height: 1px;
                background: #333;
                margin: 6px auto 4px; /* Réduit */
            }

            .signature-text {
                color: #7f8c8d;
                font-size: 8px;
                font-style: italic;
            }

            .copy-label-pdf {
              font-size: 7pt;
              font-weight: bold;
              padding: 1mm 2mm;
              border-radius: 1mm;
              background: #7691b9ff;
              color: white;
              text-align: center;
              padding: 4px 8px;

            }

            .pdf-preview .archive-copy .copy-label-pdf {
              background: #dc3545;
              color: white;
            }

            /* Label de copie 
            .copy-label-pdf {
                font-size: 9px;
                color: #95a5a6;
                padding: 4px 8px;
                border-top: 1px solid #eee;
                text-align: center;
                background: white;
                border-radius: 4px;
                font-weight: bold;
                letter-spacing: 1px;
            }*/

            /* Styles d'impression */
            @media print {
                body {
                    margin: 0;
                    padding: 0;
                    background: white;
                    width: 210mm;
                    min-height: 297mm;
                }

                .a4-portrait-container {
                    width: 210mm;
                    min-height: 297mm;
                    margin: 0;
                    padding: 0;
                    border: none;
                    box-shadow: none;
                    page-break-after: always;
                }

                .a5-landscape-copy {
                    width: 210mm;
                    height: 148.5mm;
                    padding: 8mm 10mm;
                    page-break-inside: avoid;
                    break-inside: avoid;
                }

                .rounded-frame {
                    border: 1px solid #ddd;
                    border-radius: 8px;
                    box-shadow: none;
                }

                /* Ligne de découpe entre les deux copies */
                .Client-copy {
                    border-bottom: 1px dashed #999;
                }

                .archive-copy {
                    border-top: 1px dashed #999;
                    border-bottom: none;
                }

                .print-button {
                    display: none !important;
                }

                /* Empêcher le débordement */
                .section-content {
                    max-height: 60mm !important;
                }
            }

            /* Bouton d'impression (visible seulement à l'écran) */
            .print-button {
                position: fixed;
                top: 20px;
                right: 20px;
                background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
                color: white;
                border: none;
                padding: 10px 20px;
                border-radius: 6px;
                cursor: pointer;
                font-size: 12px;
                font-weight: bold;
                box-shadow: 0 3px 10px rgba(52, 152, 219, 0.3);
                z-index: 1000;
                transition: all 0.3s ease;
            }

            .print-button:hover {
                background: linear-gradient(135deg, #2980b9 0%, #1f639b 100%);
                transform: translateY(-2px);
                box-shadow: 0 5px 15px rgba(52, 152, 219, 0.4);
            }

            /* Ajustements pour l'affichage à l'écran */
            @media screen {
                body {
                    padding: 20px;
                    background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
                }

                .a4-portrait-container {
                    box-shadow: 0 5px 20px rgba(0,0,0,0.15);
                    margin: 0 auto;
                    border-radius: 12px;
                    overflow: hidden;
                }

                /* Ajustement d'échelle pour petits écrans */
                @media screen and (max-width: 1200px) {
                    body {
                        transform: scale(0.8);
                        transform-origin: top center;
                    }
                }

                @media screen and (max-width: 900px) {
                    body {
                        transform: scale(0.6);
                    }
                }
            }

            /* Amélioration du défilement à l'écran */
            .section-content::-webkit-scrollbar {
                width: 4px;
            }

            .section-content::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 2px;
            }

            .section-content::-webkit-scrollbar-thumb {
                background: #3498db;
                border-radius: 2px;
            }

            .section-content::-webkit-scrollbar-thumb:hover {
                background: #2980b9;
            }

            /* Animation pour les cadres */
            .rounded-section {
                transition: all 0.3s ease;
            }

            .rounded-section:hover {
                transform: translateY(-2px);
                box-shadow: 0 4px 8px rgba(0,0,0,0.1);
            }
        </style>
    </head>
    <body>
        <button class="print-button" onclick="window.print()">🖨️ Imprimer le Reçu</button>
        
        <div class="a4-portrait-container">
            <!-- Copie Client (en haut) -->
            ${generateA5LandscapeCopy('Client-copy')}
            
            <!-- Copie Archive (en bas) -->
            ${generateA5LandscapeCopy('archive-copy')}
        </div>

        <script>
            // Optionnel: Auto-impression après chargement
            window.onload = function() {
                // Décommenter pour auto-impression
                // setTimeout(() => {
                //     window.print();
                // }, 1000);
                
                // Ajouter des effets visuels
                document.querySelectorAll('.rounded-section').forEach(section => {
                    section.style.transition = 'all 0.3s ease';
                });
            };

            // Ajuster la hauteur des sections de contenu
            function adjustContentHeights() {
                const sections = document.querySelectorAll('.section-content');
                sections.forEach(section => {
                    const parent = section.closest('.consultation-section-adjacent, .analyses-section-adjacent, .single-section-content');
                    if (parent) {
                        const parentHeight = parent.clientHeight;
                        const titleHeight = parent.querySelector('.section-title')?.clientHeight || 0;
                        const totalHeight = parent.querySelector('.section-total')?.clientHeight || 0;
                        const padding = 10; // padding vertical
                        section.style.maxHeight = (parentHeight - titleHeight - totalHeight - padding) + 'px';
                    }
                });
            }

            // Ajuster après chargement et redimensionnement
            window.addEventListener('load', adjustContentHeights);
            window.addEventListener('resize', adjustContentHeights);
        </script>
    </body>
    </html>
  `;
};

export default genererHTMLReçu;